import React, { FC } from 'react';
import { BrowserRouter } from 'react-router-dom';

import ActivityFeedPageContainer from 'buyside/components/container/ActivityFeedPageContainer';
import HomePage from 'buyside/components/presentation/ActivityFeedPage/homePage';

const ActivityFeedPageRoot: FC = () => {
  const oldHome = new RegExp(window.btoa('old home page')).test(window.location.search);

  if (oldHome) {
    document.getElementById('home')?.classList.add('feed-background');
    return <ActivityFeedPageContainer />;
  } else {
    document.getElementById('mainReactApp')?.setAttribute('data-no-padding', 'true');
    return (
      <BrowserRouter basename="/pro">
        <HomePage />
      </BrowserRouter>
    );
  }
};

export default ActivityFeedPageRoot;
